/**
 * «Юниверситет» (28.09): учебный пакет филиала — GET /api/uni/:pack (за авторизацией,
 * из R2 uni/<pack>/pack.json). В бандл и public пакет не попадает: в нём ответы и коды
 * загадок («Ничего из этого не класть в apps/web/public и не вшивать в бандл» — ТЗ).
 */
import { useCallback, useEffect, useState } from "react";
import type { UniPack } from "@ub/shared/uni";
import { api } from "../../../api/client";
import { ApiException } from "../../../api/types";

export interface UniPackState {
  pack: UniPack | null;
  error: string | null;
  reload: () => void;
}

export function useUniPack(packId: string): UniPackState {
  const [pack, setPack] = useState<UniPack | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let alive = true;
    setError(null);
    setPack(null);
    api<UniPack>(`/api/uni/${encodeURIComponent(packId)}`)
      .then((p) => {
        if (!alive) return;
        if (!p || !Array.isArray(p.rooms) || !p.items) { setError("Учебный пакет повреждён"); return; }
        setPack(p);
      })
      .catch((e: unknown) => {
        if (!alive) return;
        setError(e instanceof ApiException && e.status === 404
          ? "Учебный пакет ещё не выложен"
          : "Не удалось загрузить обучение. Проверь связь");
      });
    return () => { alive = false; };
  }, [packId, nonce]);

  const reload = useCallback(() => setNonce((n) => n + 1), []);
  return { pack, error, reload };
}
